export default __webpack_public_path__ + "static/media/cardboard-box.268bf4c1.svg";